import React, { Component } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import Dashboard from "../containers/Dashboard";
import RelatedPartySave from "../components/RelatedPartyCreation/RelatedPartySave";
import RelatedPartiesList from "../components/RelatedPartiesList/RelatedPartiesList";
import RelatedPartiesDeleteEntries from "../components/RelatedPartiesDeleteEntries/RelatedPartiesDeleteEntries";
import PageNotFound from "../components/PageNotFound/PageNotFound";
import Login from "../components/Login/Login";
import UsersRoleList from "../components/Admin/UsersRoleList/UsersRoleList";
import Users from "../components/Admin/Users/Users";
import UserRoleCreation from "../components/Admin/UserRoleCreation/UserRoleCreation";
import PendingApprovalList from "../components/PendingApprovalList/PendingApprovalList";
import ArchiveApprovalList from "../components/ArchiveApprovalList/ArchiveApprovalList";
import Room from "../components/Room/Room";
import CreateRoom from "../components/CreateRoom/CreateRoom";
import Setting from "../components/Setting/Setting";
import AppoinmentCreation from "../components/AppoinmentCreation/AppoinmentCreation";
import BookTime from "../components/BookTime/BookTime";
import AppoinmentList from "../components/AppoinmentList/AppoinmentList";
import CreateProcedures from "../components/CreateProcedures/CreateProcedures";
import ProcedureList from "../components/ProcedureList/ProcedureList";
import ConductAppoinment from "../components/ConductAppoinment/ConductAppoinment";
import AddInventory from "../components/AddInventory/AddInventory";
import InventoryList from "../components/InventoryList/InventoryList";
import AddSubCategory from "../components/AddSubCategory/AddSubCategory";
import SubCategoryList from "../components/SubCategoryList/SubCategoryList";
import InventorySummery from "../components/InventorySummery/InventorySummery";
import InventoryAuditTrail from "../components/InventoryAuditTrail/InventoryAuditTrail";
import SendPayment from "../components/Payment/SendPayment/SendPayment";
import ReceivePayment from "../components/Payment/ReceivePayment/ReceivePayment";
import PaymentHistory from "../components/Payment/PaymentHistory/PaymentHistory";
import CreateInvoice from "../components/Billing/CreateInvoice/CreateInvoice";
import CreateInvoiceSupplier from "../components/Billing/CreateInvoiceSupplier/CreateInvoiceSupplier";
import InvoiceDetails from "../components/Billing/InvoiceDetails/InvoiceDetails";
import EditAccount from "../components/EditAccount/EditAccount";
import InvoiceList from "../components/Billing/InvoiceList/InvoiceList";
import GeneralSetting from "../components/GeneralSetting/GeneralSetting";
import PracticeComplience from "../components/PracticeComplience/PracticeComplience";

import ttmLoader from "../assets/images/ttm-loader.gif";
import AuditTrail from "../components/AuditTrail/AuditTrail";
import Statements from "../components/Statements/Statements";
import PageAccessDenied from "../components/PageAccessDenied/PageAccessDenied";
import PermissionRoute from "../routes/PermissionRoute";
import Permissions from "../utils/PermissionKeys.json"
import ReportIncome from "../components/ReportIncome/ReportIncome";
import AuthenticationRoute from "../routes/AuthenticationRoute";
import AppointmentsCalendar from "../components/AppointmentsCalendar/AppointmentsCalendar";
import Templates from "../components/Templates/Templates";
import Notifications from "../components/Notifications/Notifications";
import MedicalNotes from "../components/MedicalNotes/MedicalNotes";
import EditSystemUser from "../components/EditSystemUser/EditSystemUser";
import history from "../utils/history";
import MediclaimDetails  from "../components/Billing/Mediclaim/MediclaimDetails/MediclaimDetails";
import MediclaimProcess from "../components/Billing/Mediclaim/MediclaimProcess/MediclaimProcess";
import MediclaimResponse from "../components/Billing/Mediclaim/MediclaimResponse/MediclaimResponse";
import MediclaimSettings  from "../components/Billing/Mediclaim/MediclaimSettings/MediclaimSettings";
import PatientList from "../components/PatientList/PatientList";
import AddPatient from "../components/AddPatient/AddPatient";
import ViewPatient from "../components/ViewPatient/ViewPatient";

class MainLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isSidebarCollapsed: false,
    };
  }
  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        isLoading: false,
      });
    }, 1100);

    // Getting window width
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    console.log(" Window width ", width);

    if (width < 991) {
      setTimeout(() => {
        this.setState({
          isSidebarCollapsed: true,
        });
      }, 200);
    }
  }
  // componentDidUpdate(){
  //   console.log('Child component did update');
  // }

  sidebarData = (data) => {
    this.setState({
      isSidebarCollapsed: data,
    });
  };
  
  goBack = () => {
    history.goBack();
  }

  render() {
    // console.log("process.env.",process.env)
    return (
      <div>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
        {/* <BrowserRouter> */}
          <main id="wrapper">
            {this.state.isLoading && (
              <div className="fullscreen-loader">
                <div className="loader-img">
                  <img
                    src={ttmLoader}
                    alt="TechToMed"
                    className="loaderImage"
                  />
                </div>
              </div>
            )}
            <div id="content-wrapper" className="d-flex flex-column">
              <Header />
              <div
                id="content"
                className={
                  this.state.isSidebarCollapsed
                    ? "content-collapsed"
                    : "content-shrink"
                }
              >
                <Sidebar sendData={this.sidebarData} />
                {/* Begin Page Content */}
                <div className="page-content">
                  <div className="container-fluid">
                    {/* <div className="mb-2">
                      <span className="goBackBtn" onClick={this.goBack}>
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back </span>
                    </div> */}
                    <Switch>
                      <AuthenticationRoute
                        path="/app/dashboard"
                        exact
                        component={Dashboard}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_CONTACTS}
                        path="/app/editcontact"
                        exact
                        component={RelatedPartySave}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_CONTACTS}
                        path="/app/editcontact/:id"
                        exact
                        component={RelatedPartySave}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_CONTACTS_LIST}
                        path="/app/contacts"
                        exact
                        component={RelatedPartiesList}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_PATIENTS_LIST}
                        path="/app/patients"
                        exact
                        component={PatientList}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_PATIENTS}
                        path="/app/editpatient"
                        exact
                        component={AddPatient}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_PATIENTS}
                        path="/app/editpatient/:id"
                        exact
                        component={AddPatient}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_PATIENTS}
                        path="/app/viewpatient/:id"
                        exact
                        component={ViewPatient}
                      />
                      {/* <Route
                        path="/app/contacts"
                        exact
                        component={RelatedPartiesList}
                      /> */}
                      <AuthenticationRoute
                        path="/app/parties-delete-entries"
                        exact
                        component={RelatedPartiesDeleteEntries}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CREATE_APPOINTMENT}
                        path="/app/createappointment"
                        exact
                        component={AppoinmentCreation}
                      />
                      <PermissionRoute
                        keyObj={Permissions.EDIT_APPOINTMENT}
                        path="/app/createappointment/:id"
                        exact
                        component={AppoinmentCreation}
                      />
                      {/* <PermissionRoute
                       keyObj={Permissions.CONDUCT_APPOINTMENT}
                        path="/app/conductappoinment"
                        exact
                        component={ConductAppoinment}
                      /> */}
                      <PermissionRoute
                        keyObj={Permissions.CONDUCT_APPOINTMENT}
                        path="/app/conductappoinment/:id"
                        exact
                        component={ConductAppoinment}
                      />
                      <AuthenticationRoute
                        path="/app/appoinmentlist"
                        exact
                        component={AppoinmentList}
                      />
                      <PermissionRoute
                      keyObj={Permissions.TRACK_INVENTORY}
                        path="/app/inventorysummery"
                        exact
                        component={InventorySummery}
                      />

                      <PermissionRoute
                        keyObj={Permissions.LOAD_INVENTORY}
                        path="/app/addsupply"
                        exact
                        component={AddInventory}
                      />
                      <PermissionRoute
                        keyObj={Permissions.LOAD_INVENTORY}
                        path="/app/addsupply/:id"
                        exact
                        component={AddInventory}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVENTORY}
                        path="/app/inventorylist"
                        exact
                        component={InventoryList}
                      />
                      <AuthenticationRoute
                        path="/app/addsubcategory"
                        exact
                        component={AddSubCategory}
                      />
                      <AuthenticationRoute
                        path="/app/subcategorieslist/:id"
                        exact
                        component={AddSubCategory}
                      />
                      <AuthenticationRoute
                        path="/app/subcategorieslist"
                        exact
                        component={SubCategoryList}
                      />
                      <AuthenticationRoute
                        path="/app/inventoryaudit"
                        exact
                        component={InventoryAuditTrail}
                      />
                      <AuthenticationRoute 
                      path="/app/blocktime" 
                      exact 
                      component={BookTime} />
                      { (JSON.parse(localStorage.getItem("USER_INFO")).systemRole == 1) &&
                      (
                      <AuthenticationRoute
                        path="/app/userrolelist"
                        exact
                        component={UsersRoleList}
                      />)}
                      <AuthenticationRoute
                        path="/app/pendingapprovallist"
                        exact
                        component={PendingApprovalList}
                      />
                      <AuthenticationRoute
                        path="/app/archivedapprovallist"
                        exact
                        component={ArchiveApprovalList}
                      />
                      <AuthenticationRoute path="/app/roomlist" exact component={Room} />
                      <PermissionRoute
                        keyObj={Permissions.CONFIGURE_ROOM}
                        path="/app/roomcreation"
                        exact
                        component={CreateRoom}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CONFIGURE_ROOM}
                        path="/app/roomcreation/:id"
                        exact
                        component={CreateRoom}
                      />
                      <AuthenticationRoute path="/app/users" exact component={Users} />
                      {/* <PermissionRoute
                        keyObj={Permissions.MANAGE_USERS_ROLES}
                        path="/app/user-role-creation"
                        exact
                        component={UserRoleCreation}
                      />
                      <PermissionRoute
                        keyObj={Permissions.MANAGE_USERS_ROLES}
                        path="/app/user-role-creation/:id"
                        exact
                        component={UserRoleCreation}
                      /> */}
                      { (JSON.parse(localStorage.getItem("USER_INFO")).systemRole == 1) &&
                      ( 
                        <AuthenticationRoute
                          keyObj={Permissions.MANAGE_USERS_ROLES}
                          path="/app/user-role-creation"
                          exact
                          component={UserRoleCreation}
                        />
                      )}
                      { (JSON.parse(localStorage.getItem("USER_INFO")).systemRole == 1) &&
                      (
                        <AuthenticationRoute
                          keyObj={Permissions.MANAGE_USERS_ROLES}
                          path="/app/user-role-creation/:id"
                          exact
                          component={UserRoleCreation}
                        />
                      )}
                      <AuthenticationRoute
                        path="/app/procedureslist"
                        exact
                        component={ProcedureList}
                      />
                      <AuthenticationRoute
                        path="/app/createprocedures"
                        exact
                        component={CreateProcedures}
                      />
                      <AuthenticationRoute
                        path="/app/createprocedures/:id"
                        exact
                        component={CreateProcedures}
                      />
                      <PermissionRoute
                        keyObj={Permissions.MAKE_PAYMENT}
                        path="/app/sendpayment"
                        exact
                        component={SendPayment}
                      />
                      <PermissionRoute
                        keyObj={Permissions.RECIEVE_PAYMENT}
                        path="/app/receivepayment"
                        exact
                        component={ReceivePayment}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_PAYMENT_TRANSACTION}
                        path="/app/paymenthistory"
                        exact
                        component={PaymentHistory}
                      />
                      <PermissionRoute
                        keyObj={Permissions.UPDATE_PRACTITIONER_DETAILS}
                        path="/app/practicecompliance"
                        exact
                        component={PracticeComplience}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CAPTURE_INVOICE}
                        path="/app/createinvoice"
                        exact
                        component={CreateInvoice}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CAPTURE_INVOICE}
                        path="/app/createinvoice/:id"
                        exact
                        component={CreateInvoice}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CAPTURE_INVOICE}
                        path="/app/createestimate"
                        exact
                        component={CreateInvoice}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CAPTURE_INVOICE}
                        path="/app/createestimate/:id"
                        exact
                        component={CreateInvoice}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CAPTURE_INVOICE}
                        path="/app/createinvoicesupplier"
                        exact
                        component={CreateInvoiceSupplier}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVOICE}
                        path="/app/invoicedetails"
                        exact
                        component={InvoiceDetails}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVOICE}
                        path="/app/invoicedetails/:id"
                        exact
                        component={InvoiceDetails}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVOICE}
                        path="/app/estimatedetails"
                        exact
                        component={InvoiceDetails}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVOICE}
                        path="/app/estimatedetails/:id"
                        exact
                        component={InvoiceDetails}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_INVOICE}
                        path="/app/invoicelist"
                        exact
                        component={InvoiceList}
                      />
                      <PermissionRoute
                        keyObj={Permissions.CONFIGURE_PICKLIST} 
                        path="/app/settings" 
                        exact 
                        component={Setting} />
                      <AuthenticationRoute
                        path="/app/generalsetting"
                        exact
                        component={GeneralSetting}
                      />
                      <PermissionRoute
                        keyObj={Permissions.MANAGE_CREDENTIALS}
                        path="/app/editaccount"
                        exact
                        component={EditAccount}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_AUDIT_TRAILS}
                        path="/app/audittrail"
                        exact
                        component={AuditTrail}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_STATEMENT}
                        path="/app/statements"
                        exact
                        component={Statements}
                      />
                      <AuthenticationRoute
                        path="/app/reportsIncome"
                        exact
                        component={ReportIncome}
                      />
                      <PermissionRoute
                        keyObj={Permissions.VIEW_CALENDAR}
                        path="/app/appointmentscalendar"
                        exact
                        component={AppointmentsCalendar}
                      />
                      { (JSON.parse(localStorage.getItem("USER_INFO")).systemRole == 1) &&
                      (
                        <AuthenticationRoute
                          path="/app/templates"
                          exact
                          component={Templates}
                        />
                      )}
                       <AuthenticationRoute
                          path="/app/notificationsboard"
                          exact
                          component={Notifications}
                        />
                        <PermissionRoute
                          keyObj={Permissions.MANAGE_LETTERS}
                           path="/app/medicalnotes"
                           exact
                           component={MedicalNotes}
                         />
                         
                        <AuthenticationRoute
                           path="/app/editsystemuser/:id"
                           exact
                           component={EditSystemUser}
                         />
                       <AuthenticationRoute
                          path="/app/claimdetails/:id"
                          exact
                          component={MediclaimDetails}
                        />
                        <AuthenticationRoute
                           path="/app/claimprocess"
                           exact
                           component={MediclaimProcess}
                         />
                         <AuthenticationRoute
                            path="/app/claimresponse/:id"
                            exact
                            component={MediclaimResponse}
                          />
                          <AuthenticationRoute
                             path="/app/claimsettings"
                             exact
                             component={MediclaimSettings}
                           />
                      <Route path="/app/access-denied" exact component={PageAccessDenied} />
                      <Route path="/app/*" exact component={PageNotFound} />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </BrowserRouter>
      </div>
    );
  }
}

export default withRouter(MainLayout);
